import React from 'react'
import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router-dom'

import { Box } from '@material-ui/core'

import { ScreenLoader } from './ScreenLoader'

import { useLogic } from '../hooks/storeHook'
import { useQuery } from '../hooks/routeHooks'
import { useLazyEffect } from '../hooks/commonHooks'

import { isEnumKey } from '../common/tsUtils'
import { required } from '../common/objectUtils'

import { MoySkladAppHookParams } from '../types/moySkladAppTypes'
import { MoySkladAppType } from '../server/mpsklad_common/MoySkladAppType'

export const MoySkladAppAuthScreen =
  observer(() => {
    const logic = useLogic()

    const {appType} = useParams<MoySkladAppHookParams>()

    // Fallback for backwards compatibility
    // TODO: This is case-sensitive, make insensitive?
    const appTypeValue = isEnumKey(appType, MoySkladAppType) ? MoySkladAppType[appType]
                                                             : MoySkladAppType.OzonAndWb

    const query = useQuery()
    const contextKey = required(query.get('contextKey'))

    useLazyEffect(() => logic.loginMoySkladApp(appTypeValue, contextKey))

    return (
      <Box width="100%" minHeight={400}>
        <ScreenLoader/>
      </Box>
    )
  })